import React, { useState, useEffect } from 'react'
import * as R from 'ramda'

import { LogoIcon } from './icons'

const spokeItems = R.repeat((
  <div />
), 12)

export default ({ hasLogo = false, uniqueID  }) => {
  const [showUniqueID, setShowUniqueID] = useState(false)

  // useEffect to show uniqueID after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowUniqueID(true)
    }, 0) // 1 seconds delay

    // Cleanup the timer when component unmounts
    return () => clearTimeout(timer)
  }, [])

  return (

  <div className={hasLogo ? 'loading-container-logo' : 'loading-container'}>
    <div className="loader">
      {
        hasLogo ? <>
          <span className={'loader-logo'}><LogoIcon /></span>
          <div className="lds-spinner small">
            {
              spokeItems
            }
          </div>
          
          {showUniqueID && <div className="unq-id">{uniqueID}</div>}
        </> : <div className="lds-spinner">
          {
            spokeItems
          }
        </div>
      }
    </div>
  </div>
  )
}

